import { useState } from 'react';
import { motion, AnimatePresence, LayoutGroup, useReducedMotion } from 'framer-motion';

const { clients, awards } = require('data/home.json');

// Variants reutilizables
const gridVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12, when: 'beforeChildren' },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
};

export default function ClientsAwardsSection() {
  const [activeTab, setActiveTab] = useState('clients');
  const reduceMotion = useReducedMotion();

  // Si el usuario prefiere reducir movimiento, anulamos offsets/animaciones largas
  const safeItemVariants = reduceMotion
    ? { hidden: { opacity: 0 }, show: { opacity: 1 } }
    : itemVariants;

  const safeTitleInitial = reduceMotion ? { opacity: 0 } : { opacity: 0, y: 20 };
  const safeTitleShow = { opacity: 1, y: 0 };

  // Ajuste de viewport: amount controla cuánta parte debe ser visible (0–1)
  // once: true -> solo una vez; ponelo en false si querés que se repita al reentrar
  const viewport = { once: true, amount: 0.2 };

  return (
    <div className="home-clients-awards container-full">
      <div className="white-container">
        <div className="clients-awards-content">

          <LayoutGroup>
            <div className="home-tabs flex gap-2 relative">
              {['clients', 'awards'].map((tab) => {
                const isActive = activeTab === tab;
                const label = tab.charAt(0).toUpperCase() + tab.slice(1);

                return (
                  <motion.button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className="home-tab relative z-0 overflow-hidden rounded-full px-6 py-3 font-semibold text-[1rem] leading-[1.5rem]"
                    animate={{ color: isActive ? '#D3FF33' : '#000000' }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    aria-pressed={isActive}
                  >
                    {isActive && (
                      <motion.div
                        layoutId="tab-highlight"
                        className="absolute inset-0 rounded-full bg-black -z-10 pointer-events-none"
                        transition={{ duration: 0.4, ease: 'easeInOut' }}
                        aria-hidden="true"
                      />
                    )}
                    {label}
                  </motion.button>
                );
              })}
            </div>
          </LayoutGroup>

          <AnimatePresence mode="wait">
            {activeTab === 'clients' && (
              <motion.div
                key="clients"
                className="home-logos-content"
                // En vez de initial/animate, usamos whileInView
                initial="hidden"
                whileInView="show"
                viewport={viewport}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >
                <motion.h2
                  className="k-title-sm lg:k-title-md xl:k-title-lg"
                  initial={safeTitleInitial}
                  whileInView={safeTitleShow}
                  viewport={viewport}
                  transition={{ duration: 0.5, ease: 'easeOut' }}
                >
                  Our friends
                </motion.h2>

                <motion.ul
                  className="clients-logos-grid"
                  variants={gridVariants}
                  initial="hidden"
                  whileInView="show"
                  viewport={viewport}
                >
                  {clients.map((client, index) => (
                    <motion.li key={index} variants={safeItemVariants}>
                      {/* img sin hover, solo entrada */}
                      <img
                        src={`/images/clients/${client.image}`}
                        alt={client.alt}
                      />
                    </motion.li>
                  ))}
                </motion.ul>
              </motion.div>
            )}

            {activeTab === 'awards' && (
              <motion.div
                key="awards"
                className="home-logos-content"
                initial="hidden"
                whileInView="show"
                viewport={viewport}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >
                <motion.h2
                  className="k-title-sm lg:k-title-md xl:k-title-lg"
                  initial={safeTitleInitial}
                  whileInView={safeTitleShow}
                  viewport={viewport}
                  transition={{ duration: 0.5, ease: 'easeOut' }}
                >
                  Our recognitions
                </motion.h2>

                <motion.ul
                  className="awards-logos-grid"
                  variants={gridVariants}
                  initial="hidden"
                  whileInView="show"
                  viewport={viewport}
                >
                  {awards.map((award, index) => (
                    <motion.li key={index} className="award-item" variants={safeItemVariants}>
                      <img
                        src={`/images/awards/${award.image}`}
                        alt={award.alt}
                      />
                    </motion.li>
                  ))}
                </motion.ul>
              </motion.div>
            )}
          </AnimatePresence>

        </div>
      </div>
    </div>
  );
}